import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  loadUnionCategoriesAndItems,
  loadUnionItemVariants,
} from 'actions/customers/loyalty';
import _ from 'lodash';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import styles from './ItemRule.css';
import NumberInputWithFeedback from '../NumberInputWithFeedback';
import ItemInputList from './ItemInputList';
import Select from '../Select';

class ItemRule extends Component {
  constructor(props) {
    super(props);
    const {
      pointFromBuyingItem,
      itemRuleTypes,
      selectedItemRuleType,
      earningRuleItems,
    } = props;
    const pointInputError =
      pointFromBuyingItem === ''
        ? null
        : this._getPointInputError(pointFromBuyingItem);
    this.state = { pointInputError };
    selectedItemRuleType === itemRuleTypes.item &&
      this._validateItemRules(earningRuleItems);
  }

  componentWillMount() {
    this.props.dispatch(loadUnionCategoriesAndItems());
    if (this.props.earningRuleItems) {
      for (let i = 0; i < this.props.earningRuleItems.length; i++) {
        const earningRuleItem = this.props.earningRuleItems[i];
        earningRuleItem.item_name &&
          this.props.dispatch(loadUnionItemVariants(earningRuleItem.item_name));
      }
    }
  }

  render() {
    const {
      itemRuleTypes,
      selectedItemRuleType,
      earningRuleItems,
      onSelectItemRuleType,
      item: { items, categories, itemVariants },
    } = this.props;
    let earningRuleCategories = [];
    if (selectedItemRuleType === itemRuleTypes.category) {
      earningRuleCategories = earningRuleItems.map(x => x.category_name);
    }
    return (
      <div className="top30">
        <div className="row">
          <div className="col-md-6">
            <div className={`${styles.title}`}>Buy</div>
          </div>
          <div className="col-md-6">
            <div className={`${styles['title-right']}`}>To gain points</div>
          </div>
        </div>
        <div className={`row ${styles['vertical-align']}`}>
          <div className="col-md-6">
            <div className={styles['single-radio']}>
              <label>
                <input
                  name="itemRuleType"
                  type="radio"
                  checked={selectedItemRuleType === itemRuleTypes.item}
                  value={itemRuleTypes.item}
                  onChange={() => onSelectItemRuleType(itemRuleTypes.item)}
                />
                <span>Items</span>
              </label>
            </div>
            <div className={styles['single-radio']}>
              <label>
                <input
                  name="itemRuleType"
                  type="radio"
                  checked={selectedItemRuleType === itemRuleTypes.category}
                  value={itemRuleTypes.category}
                  disabled={_.isEmpty(categories)}
                  onChange={() => onSelectItemRuleType(itemRuleTypes.category)}
                />
                <span>Any items from a Category</span>
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className={`${styles['itemrule-right']}`}>
              <NumberInputWithFeedback
                inputValue={this.props.pointFromBuyingItem}
                onChangeValue={this._onChangePoint}
                suffix=" Points"
                placeholder="0 Points"
                errorMessage={this.state.pointInputError}
              />
            </div>
          </div>
        </div>
        <div
          className="col-md-12 top30 bottom10"
          style={{ padding: '0px', minWidth: '474px' }}
        >
          {selectedItemRuleType === itemRuleTypes.item && (
            <ItemInputList
              items={items}
              buildOptions={this._buildOptions}
              itemVariants={itemVariants}
              earningRuleItems={earningRuleItems}
              onSelectItem={this._onSelectItem}
              onSelectItemVariant={this._onSelectItemVariant}
              addItem={this._addItem}
              addNewItem={this._addNewItem}
              removeItem={this._removeItem}
            />
          )}
          {selectedItemRuleType === itemRuleTypes.category && (
            <Select
              options={this._buildOptions(categories)}
              disabled={_.isEmpty(categories)}
              value={earningRuleCategories}
              placeholder="Search Categories"
              closeOnSelect={false}
              multi
              onChange={this._onChangeCategory}
            />
          )}
        </div>
      </div>
    );
  }

  _onChangeCategory = selectedCategories => {
    let categoryNames = [];
    const earningRuleItems = [];
    if (!selectedCategories) {
      return;
    }
    const type = this.props.itemRuleTypes.category;
    categoryNames = _.map(selectedCategories, 'value');
    categoryNames.forEach(categoryName => {
      earningRuleItems.push({
        type,
        category_name: categoryName,
      });
    });

    this.props.setEarningRuleItems(earningRuleItems);
    this._validateItemRules(earningRuleItems);
  };

  _onSelectItem = (itemIndex, selectedItem) => {
    if (!selectedItem) {
      return;
    }
    const earningRuleItem = {
      type: this.props.itemRuleTypes.item,
      item_name: selectedItem.value,
      category_name: null,
      item_variant_names: null,
    };
    const earningRuleItems = update(this.props.earningRuleItems, {
      [itemIndex]: { $set: earningRuleItem },
    });
    this.props.setEarningRuleItems(earningRuleItems);
    this.props.dispatch(loadUnionItemVariants(selectedItem.value));
    this._validateItemRules(earningRuleItems);
  };

  _onSelectItemVariant = (itemIndex, selectedItemVariants) => {
    if (!selectedItemVariants) {
      return;
    }
    const earningRuleItem = {
      type: this.props.itemRuleTypes.item,
      item_name: this.props.earningRuleItems[itemIndex].item_name,
      item_variant_names: _.map(selectedItemVariants, 'value'),
    };
    const earningRuleItems = update(this.props.earningRuleItems, {
      [itemIndex]: { $set: earningRuleItem },
    });
    this.props.setEarningRuleItems(earningRuleItems);
    this._validateItemRules(earningRuleItems);
  };

  _addItem = e => {
    e.preventDefault();
    const newItem = {
      type: this.props.itemRuleTypes.item,
      item_name: null,
      category_name: null,
      item_variant_names: [],
    };
    const earningRuleItems = [...this.props.earningRuleItems, newItem];
    this.props.setEarningRuleItems(earningRuleItems);
    this._validateItemRules(earningRuleItems);
  };

  _addNewItem = newItem => {
    const earningRuleItems = [...this.props.earningRuleItems, newItem];
    this.props.setEarningRuleItems(earningRuleItems);
    this._validateItemRules(earningRuleItems);
  };

  _removeItem = itemIndex => {
    const earningRuleItems = update(this.props.earningRuleItems, {
      $splice: [[itemIndex, 1]],
    });
    this.props.setEarningRuleItems(earningRuleItems);
    this.props.earningRuleItems[0].item_name != null &&
    this.props.pointFromBuyingItem > 0
      ? this.props.setDisabledNext(false)
      : this.props.setDisabledNext(true);
    this._validateItemRules(earningRuleItems);
  };

  _onChangePoint = (e, rawPoint) => {
    const maximum = 999999999999;
    if (rawPoint > maximum) {
      rawPoint = this.props.pointFromBuyingItem;
    }

    if ($.isNumeric(rawPoint)) {
      rawPoint = parseInt(rawPoint);
    }

    const pointInputError = this._getPointInputError(rawPoint);
    this.props.setPointFromBuyingItem(rawPoint);

    pointInputError === ''
      ? this._validateItemRules(this.props.earningRuleItems, rawPoint)
      : this.props.setDisabledNext(true);

    this.setState({ pointInputError });
  };

  _getPointInputError = point => {
    let pointInputError = '';
    if (point <= 0) {
      pointInputError = 'Please enter a value';
    }

    return pointInputError;
  };

  _buildOptions = names => {
    if (_.isEmpty(names)) {
      return [];
    }
    return _.without(names, '').map(name => {
      return { value: name, label: name, disabled: false };
    });
  };

  _validateItemRules = (itemRules, point) => {
    if (!point) {
      point = this.props.pointFromBuyingItem;
    }
    if (
      itemRules.length === 0 ||
      this.props.pointFromBuyingItem <= 0 ||
      point === ''
    ) {
      this.props.setDisabledNext(true);
      return;
    }
    for (let i = 0; i < itemRules.length; i++) {
      const itemRule = itemRules[i];
      if (
        itemRule.type === 'ITEM' &&
        (itemRule.item_name === null ||
          itemRule.item_variant_names === null ||
          itemRule.item_variant_names === undefined ||
          (itemRule.item_variant_names &&
            itemRule.item_variant_names.length === 0))
      ) {
        this.props.setDisabledNext(true);
        return;
      }
    }
    this.props.setDisabledNext(false);
  };
}

ItemRule.propTypes = {
  selectedItemRuleType: PropTypes.string.isRequired,
  itemRuleTypes: PropTypes.array.isRequired,
  pointFromBuyingItem: PropTypes.number.isRequired,
  setPointFromBuyingItem: PropTypes.func.isRequired,
  setEarningRuleItems: PropTypes.func.isRequired,
  setDisabledNext: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  earningRuleItem: PropTypes.object.isRequired,
  itemVariants: PropTypes.array.isRequired,
  itemOnChange: PropTypes.func.isRequired,
  itemVariantOnChange: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { item } = state.customers;
  return { item };
}

export default connect(mapStateToProps)(ItemRule);
